export default {
  namespaced: true,

  state: () => ({
    couriers: [],
  }),

  mutations: {
    SET_COURIERS_LIST(state, payload) {
      state.couriers = payload
    },
  },

  actions: {
    async getCourierList({ commit }) {
      try {
        const url = '/v1/couriers'

        const response = await this._vm.$http.get(url)

        commit('SET_COURIERS_LIST', response.data.data.rows)

        return response.data
      } catch (error) {
        return error
      }
    },
    async fetchSelection(_, payload) {
      try {
        const params = {
          'filter[keyword]': payload && payload['filter[keyword]'] ? payload['filter[keyword]'] : undefined,
          'filter[id]': payload && payload.ids ? payload.ids : undefined,
          per_page: payload && payload.perPage ? payload.perPage : undefined,
        }
        const url = '/v1/admin/couriers/selection'

        const response = await this._vm.$http.get(url, { params })

        return response.data.data
      } catch (error) {
        return []
      }
    },
    async getBrandCouriers({ commit }, brandId) {
      try {
        const url = `/v1/admin/merchants/${brandId}/courier-services`

        const response = await this._vm.$http.get(url)
        const couriers = response.data.data

        const selectedCouriers = couriers.map(courier => ({
          ...courier,
          courier_id: courier.id,
        }))
        commit('brand/SET_SELECTED_COURIERS', selectedCouriers, { root: true })

        return response.data
      } catch (error) {
        return error
      }
    },
  },
}
